import type { FieldValueListResponseApi } from '@ingenico/api-sdk-provisioning-public';
import type { ProvisioningOrganizationFieldValuesResponse } from '../../../models/organization.model';

export function mapProvisioningOrganizationFieldsValues(
  response: FieldValueListResponseApi,
): ProvisioningOrganizationFieldValuesResponse {
  return response;
}
